<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-03-30 15:18:56
 * @LastEditors: 刘小二
 * @LastEditTime: 2023-03-31 09:52:12
 * @Description: 设置产品价格
 * @FilePath: /icps_pcweb/src/views/platform/ICPS/internetSales/dialog/setProductDialog.vue
-->
<template>
  <el-dialog v-dialogDrag :visible.sync="setDialog" width="580px" :close-on-click-modal="false" :before-close="close">
    <span slot="title" class="dialog-title">设置产品价格</span>
    <div class="dialoginfo">
      <el-form ref="low" :inline="true" :rules="rules" :model="from" label-width="auto">
        <el-form-item prop="priceType">
          <span slot="label">价格类型：</span>
          <el-select v-model="from.priceType" placeholder="请选择" @change="selectPriceType">
            <el-option v-for="item in optionsType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="effectiveTime">
          <span slot="label">生效日期：</span>
          <el-date-picker v-model="from.effectiveTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
        </el-form-item>
        <el-form-item prop="taxRate">
          <span slot="label">税率：</span>
          <el-input v-model="from.taxRate" disabled placeholder="请输入" type="Number" clearable style="width: 220px">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="sureRecurrent">
          <span slot="label">价格复用:</span>
          <el-select v-model="from.multiplexResordId" placeholder="请选择">
            <el-option v-for="item in resordlist" :key="item.id" :label="item.effectiveTime" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="close()">取 消</el-button>
      <el-button class="bottom_all" style="margin-left: 24px" @click="save()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveReadjustPricesResord,queryResordlist } from "@/api/GHnumber/contractPrice.js";
export default {
  props: {
    setDialog: {
      type: Boolean,
      default: false,
    },
    contractId: {
      type: String,
      default: "",
    },
    taxRate: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      rules: {
        priceType: [{ required: true, message: "请选择", trigger: "change" }],
        effectiveTime: [{ required: true, message: "请选择", trigger: "change" }],
        taxRate: [{ required: true, message: "请输入", trigger: "change" }],
      },
      from: {
        effectiveTime: "",
        priceType: "",
        contractId: "",
        taxRate: "",
        multiplexResordId:"",
      },
      optionsType: [
        { value: "1", label: "产品价格" },
        { value: "2", label: "协商价格" },
        { value: "3", label: "信息价格" },
        { value: "4", label: "特殊价格" },
      ],
      resordlist:[],
    };
  },
  watch: {
    taxRate(val) {
        this.from.taxRate = val*100;
    },
  },
  mounted(){},
  methods: {
    selectPriceType(){
      let params= {
        contractId :this.contractId,
        sureMaintain:1,
        priceType:this.from.priceType
      }
      queryResordlist(params).then(res => {
        if(res.code == 1001) {
          this.resordlist = res.data
        }
      })
    },
    close() {
      this.$refs["low"].resetFields();
      this.from.multiplexResordId = ''
      this.$emit("closeDialog", false);
    },
    save() {
      this.from.contractId = this.contractId;
      this.from.taxRate = (this.from.taxRate / 100).toFixed(2);
      if (!this.from.contractId) {
        this.$message({ message: "缺少工程ID～！", type: "warning" });
        return;
      }
      this.$refs["low"].validate(valid => {
        if (valid) {
          this.saveReadjustPricesResordFun(this.from);
        } else {
          return false;
        }
      });
    },
    saveReadjustPricesResordFun(params) {
      saveReadjustPricesResord(params).then(res => {
        if (res.code == 1001) {
          this.$emit("saveProdectFun");
          this.close();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>